import request from '@/utils/request'
const qs = require('qs')

// 获取数据产品统计维度
export function listProductDimension () {
  return request({
    url: '/ooh-dm/v1/data/product/open/listProductDimension',
    method: 'POST'
  })
}
// 获取可以提供服务的城市列表
export function listCityInfos (data) {
  return request({
    url: '/ooh-dm/v1/data/product/open/listCityInfos',
    method: 'POST',
    params: data
  })
}
// 获取站点周围公交的信息
export function listBusInfos (data) {
  return request({
    url: '/ooh-dm/v1/data/product/open/listBusInfos',
    method: 'POST',
    data: qs.stringify(data)
  })
}
